var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcInlineConnection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-inline-connection") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.7222,79.9999 C16.6492,79.9999 11.4322,79.9999 6.2162,74.7829 C0.9992,69.5669 0.9992,64.3509 0.9992,55.2779 L0.9992,24.7219 C0.9992,15.6489 0.9992,10.4329 6.2162,5.2159 C11.4322,-0.0001 16.6492,-0.0001 25.7222,-0.0001 L56.2782,-0.0001 C65.3512,-0.0001 70.5682,-0.0001 75.7842,5.2159 C80.9992,10.4329 80.9992,15.6489 80.9992,24.7219 L80.9992,55.2779 C80.9992,64.3509 80.9992,69.5669 75.7842,74.7829 C70.5682,79.9999 65.3512,79.9999 56.2782,79.9999 L25.7222,79.9999 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Legend-Expanded",
    transform: "translate(-690.000000, -415.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(586.000000, 165.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Schematic-View",
    transform: "translate(55.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tag-+-Component-Copy-3",
    transform: "translate(0.000000, 242.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Connector",
    transform: "translate(38.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("use", {
    id: "Fill-1",
    stroke: "#5A6284",
    mask: "url(#mask-2)",
    strokeWidth: 8,
    strokeDasharray: "8,4",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(25.000000, 20.000000)",
    fill: "#FEFEFE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.9165,7.8774 L29.0835,7.8774 C30.1875,7.8774 31.0835,8.7734 31.0835,9.8774 L31.0835,28.9884 C31.0835,32.8544 27.9485,35.9884 24.0835,35.9884 L7.9165,35.9884 C4.0515,35.9884 0.9165,32.8544 0.9165,28.9884 L0.9165,9.8774 C0.9165,8.7734 1.8125,7.8774 2.9165,7.8774",
    id: "Fill-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3755,10.3774 C23.9945,10.3774 22.8755,9.2584 22.8755,7.8774 L22.8755,6.0114 C22.8755,5.7354 22.6505,5.5114 22.3755,5.5114 L9.6245,5.5114 C9.3495,5.5114 9.1245,5.7354 9.1245,6.0114 L9.1245,7.8774 C9.1245,9.2584 8.0055,10.3774 6.6245,10.3774 C5.2435,10.3774 4.1245,9.2584 4.1245,7.8774 L4.1245,6.0114 C4.1245,2.9784 6.5925,0.5114 9.6245,0.5114 L22.3755,0.5114 C25.4075,0.5114 27.8755,2.9784 27.8755,6.0114 L27.8755,7.8774 C27.8755,9.2584 26.7565,10.3774 25.3755,10.3774",
    id: "Fill-6"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInlineConnection);
export default __webpack_public_path__ + "static/media/ic-inline-connection.b2646b9f2672e4175db7ec6944b70bc5.svg";
export { ForwardRef as ReactComponent };